const ja = {
  // Navigation
  nav_plan: 'プラン',
  nav_itinerary: '旅程',
  nav_saved: '保存済み',

  // Header
  explore_photos: '写真を探索',
  sign_in: 'ログイン',

  // Plan screen
  new_trip: '+ 新しい旅行',
  add_city_header: '都市を追加',
  city_placeholder: '都市名を入力…',
  add_cities_empty: '都市を追加して旅行計画を始めましょう',
  dest_bangkok: 'バンコク', dest_paris: 'パリ', dest_london: 'ロンドン', dest_dubai: 'ドバイ',
  dest_singapore: 'シンガポール', dest_tokyo: '東京', dest_new_york: 'ニューヨーク',
  dest_istanbul: 'イスタンブール', dest_kuala_lumpur: 'クアラルンプール', dest_seoul: 'ソウル',
  hero_badge: 'AI旅行プランニング',
  hero_title_line1: '次の旅行は、',
  hero_title_line2: '完璧に計画しましょう。',
  hero_subtitle: '目的地をタップして今すぐ計画を始めよう',
  most_visited_label: '人気の旅行先',
  popular_destinations: '人気の旅行先',
  or_type_your_own: 'または直接入力',
  where_going_label: 'どこへ行きますか？',
  expanding_region: (r) => `${r}の主要都市を検索中…`,
  tap_to_explore: '— タップして探索',
  attraction_count: (n) => `${n} 件のスポット`,
  show_less: '閉じる',
  read_more: 'もっと見る',
  more: 'もっと見る',
  less: '閉じる',
  no_attractions: 'まだスポットが追加されていません',
  add_attraction_placeholder: (city) => `${city} でスポットを追加…`,
  auto_add_title: 'おすすめスポットを自動追加',
  preferences_label: '興味',
  all_types_label: 'すべてのタイプ',
  edit_interests: '興味を編集…',
  plan_framing_msg: '気に入ったものを残し、不要なものを削除して — 日程プランを生成しましょう。',
  add_back: '元に戻す',
  added_label: '追加済み',
  refresh_attractions: 'スポットを再読み込み',
  plan_multi_summary: (n, m) => `${n} 都市 · ${m} か所`,
  filter_onboarding_msg: 'スポットをカスタマイズ',
  filter_onboarding_sub: 'タイプをタップして絞り込む — そのフィルターで再生成します。',
  explore_nearby: '周辺を探索',
  explore_nearby_sub: '旅行の見どころの写真を見る',
  finding_attractions: 'スポットを検索中…',
  finding_attractions_1: 'AIにおすすめを聞いています…',
  finding_attractions_2: '人気スポットを探しています…',
  finding_attractions_3: 'もうすぐ完了…',
  generating_msg_1: '日程を計画中…',
  generating_msg_2: 'おすすめスポットを探し中…',
  generating_msg_3: '旅程を作成中…',
  view_itinerary: '旅程を見る',
  generate_itinerary: '旅程を作成',
  filterLabel: (label) => ({ 'All': 'すべて', 'Culture': '文化', 'Nature': '自然', 'Entertainment': 'エンタメ', 'Shopping': 'ショッピング', 'Food & Drink': 'グルメ', 'Kids': 'キッズ', 'Seniors': 'シニア' })[label] ?? label,

  // Itinerary screen
  rename: '名前を変更',
  days: (n) => `${n} 日間`,
  unsaved_dot: '未保存の変更',
  share_itinerary: '旅程を共有',
  copy: 'コピー',
  copied: 'コピーしました！',
  add_more_attractions: 'スポットを追加',
  search_city_placeholder: '都市を検索…',
  plus_city: '+ 都市',
  your_cities: 'あなたの都市',
  unscheduled_count: (n) => `未スケジュールのスポット（${n}件）`,
  drag_to_schedule: '日程にドラッグしてスケジュールを設定',
  loading_details: '詳細を読み込み中…',
  drag_here: 'スポットをここにドラッグ',
  day_label: (n) => `${n} 日目`,
  activity_count: (n) => `${n} 件のアクティビティ`,
  add_note: '+ メモを追加',
  note_placeholder: 'この日のメモ — ホテル情報、ランチ場所、リマインダーなど…',
  save_note: 'メモを保存',
  cancel: 'キャンセル',
  continue_in_city: '既存の都市で続ける',
  change_back: '← 変更',
  save: '保存',
  hotel_nights_label: '泊数',
  hotel_name_label: 'ホテル名',
  restaurant_label: 'レストラン（任意）',
  search_hotel: 'ホテルを検索…',
  search_restaurant: 'レストランを検索…',
  searching: '検索中…',
  address_label: '住所',
  time_label: '時刻',
  duration_label: '所要時間',
  notes_label: 'メモ',
  time_placeholder: '例：午前9:00',
  duration_placeholder: '例：2時間',
  notes_placeholder: '例：午後3時チェックイン、プールビューの部屋…',
  drag_to_reorder: 'ドラッグして並べ替え',
  details: '詳細',
  edit: '編集',
  snip: 'Snip',
  remove: '削除',
  move_to_day_picker: '日程を移動…',
  trip_start_date: '旅行開始日',
  itinerary_photo_sub: 'あなたの都市に基づくAI提案',
  itinerary_photo_cta: '旅のかくれた名所を発見しよう',
  hotel: 'ホテル',
  meal_at: (restaurant) => `${restaurant} にて`,
  add_day: '日を追加',
  save_changes: '変更を保存',
  saved_check: '保存済み ✓',
  save_itinerary: '旅程を保存',
  print_export: '🖨️ 印刷 / PDF出力',
  photos_details: '写真と詳細',

  // Saved screen
  snip_requires_account: 'ブックマークを保存するには無料アカウントを作成してください',
  sign_in_to_save:'ログインして旅行を保存・閲覧',
  sign_in_or_create: 'ログインまたはアカウント作成',
  snips: 'Snips',
  place_count: (n) => `${n} 件`,
  trips: '旅行',
  loading_trips: '旅行を読み込み中…',
  no_saved_trips: '保存済みの旅行はありません',
  add_to_plan: 'プランに追加',
  add_to_itinerary_btn: '旅程に追加',
  untitled_trip: '無題の旅行',
  open: '開く',

  // User menu
  signed_in_as: 'ログイン中：',
  change_password: 'パスワードを変更',
  delete_user_menu: 'ユーザーを削除',
  sign_out: 'ログアウト',

  // Load saved trip confirmation
  load_trip_confirm_title: '保存済みの旅行を開きますか？',
  load_trip_confirm_msg: '現在のプランは破棄されます。保持したい場合は先に保存してください。',

  // New trip confirmation
  unsaved_changes_title: '未保存の変更',
  unsaved_changes_msg: '現在の旅行には未保存の変更があります。新しい旅行を始めますか？',
  discard_start_new: '破棄して新規作成',
  new_trip_tab_title: '新しい旅行を始めますか？',
  new_trip_tab_msg: '現在の旅程は消去されます。保持したい場合は先に保存してください。',
  start_fresh: '最初からやり直す',

  // Auth modal
  create_account: 'アカウント作成',
  email_placeholder: 'メールアドレス',
  password_placeholder: 'パスワード',
  i_agree_to: '同意します：',
  terms_of_service: '利用規約',
  privacy_policy: 'プライバシーポリシー',
  and: 'および',
  no_account: 'アカウントをお持ちでない方は ',
  have_account: 'すでにアカウントをお持ちの方は ',
  network_error: 'ネットワークエラーです。再度お試しください',
  err_email_exists: 'このメールアドレスはすでに登録されています',
  err_invalid_credentials: 'メールアドレスまたはパスワードが無効です',
  err_email_password_required: 'メールアドレスとパスワードは必須です',
  err_password_too_short: 'パスワードは6文字以上必要です',

  // Change password modal
  select_user: 'ユーザーを選択…',
  new_password_placeholder: '新しいパスワード（6文字以上）',
  update_password: 'パスワードを更新',
  password_updated: 'パスワードを更新しました',
  select_a_user: 'ユーザーを選択してください',
  network_error_short: 'ネットワークエラー',

  // Delete user modal
  delete_user_trips: 'ユーザーと旅行を削除',
  deleted_user: (email) => `${email} を削除しました`,

  // Photo mode
  photo_loading_msg_1: '素晴らしいスポットを探しています…',
  photo_loading_msg_2: '写真と詳細を確認中…',
  photo_loading_msg_3: 'もうすぐ完了…',
  finding_places: 'あなたのための場所を探しています…',
  could_not_load_places: '場所を読み込めませんでした',
  no_places: '表示する場所がありません',
  ai_error: 'AIへの接続に問題が発生しました。少し経ってから再試行してください。',
  add_cities_suggestions: '都市を追加するか場所を保存して、パーソナライズされた提案を受け取りましょう。',
  retry: '再試行',
  close: '閉じる',
  finding_more_places: 'さらに場所を探しています…',
  seen_it_all: 'すべて見ました！',
  photo_limit_msg: 'このセッションの50件制限に達しました。',
  check_snips: 'Snipsで保存した場所を確認しましょう',
  photo_unavailable: '写真なし',
  loading: '読み込み中…',
  skip: 'スキップ',
  plus_itinerary: '+ 旅程',
  plus_plan: '+ プラン',
  photo_explore_title: '写真探索',
  photo_explore_sub: 'ビジュアルで場所を発見',
  swipe_lr: '左右にスワイプしてスキップ',
  swipe_up: '上にスワイプしてスキップ',
  lets_go: 'はじめましょう',
  tutorial_skip_desc: 'このスポットをスキップ',
  tutorial_snip_desc: 'Snipsコレクションに保存して後で確認',
  tutorial_add_plan_desc: 'プランタブに追加',
  tutorial_add_itinerary_desc: '現在のスケジュールに直接追加',
  tutorial_swipe_hint: '左右または上にスワイプしてスキップも可能',

  // Footer
  copyright: '© 2026 Pazzie Inc.',
  terms: '利用規約',
  privacy: 'プライバシー',
  sample_itineraries: 'サンプル旅程',
  browse_all_itineraries: 'すべて見る →',

  // Legal overlay
  back_to_app: '← SnipTripに戻る',

  // Error boundary
  something_wrong: 'エラーが発生しました',
  reload: '再読み込み',

  // Print view
  copy_text: 'テキストをコピー',
  copied_check: '✓ コピーしました',

  // Logic / computed strings
  copy_of: (name) => `${name} のコピー`,
  transportation: '交通',
  meal: '食事',

  // Chat mode
  chat_mode_link: 'またはAIチャットで計画',
  chat_back: '← ビルドに戻る',
  chat_input_placeholder: 'メッセージ…',
  chat_error: 'エラーが発生しました。再試行しますか？',
  chat_cities_count: (n) => `${n} 都市`,
  chat_places_count: (n) => `${n} か所`,
  chat_no_cities: 'まだ都市が追加されていません',

  // Discovery panels
  thinking_where: 'どこへ連れて行こうか考えています…',
  couldnt_load_suggestions: '提案を読み込めませんでした。再試行しますか？',
  back: '← 戻る',
  no_new_suggestions: '新しい提案はありません — 別の質問をお試しください。',
  back_to_questions: '← 質問に戻る',
  dismiss: '閉じる',
  where_to_next_header: '次はどこへ？',
  describe_place: '場所の種類を説明…',
  go: '決定',
  finding_ideas: 'アイデアを探しています…',
  more_attractions: 'さらにスポット…',
  different_angle: 'または別の角度で探索：',
  mood_for: '今どんな気分ですか？',
  back_questions_short: '← 質問',
  describe_looking_for: '何を探しているか説明…',
  where_to_next_trigger: (city) => city ? `+ ${city}の次はどこへ？` : '+ 次はどこへ？',
  what_else_trigger: (city) => `+ ${city}周辺で他に何を追加しますか？`,
  day_chip_add_attraction: 'スポットを追加',
  day_chip_add_city: '近くの都市を追加',
  auto_populate_prompt: (city) => `${city}の人気スポットを自動提案しますか？`,
  auto_populate_yes: 'はい、提案して',
  auto_populate_no: '自分で追加します',
  or_discover_new: '+ または新しい場所を発見',
  select: '選択',
  add: '追加',
  freeform_cta: 'その他 — 自分で説明する',
};

export default ja;
